module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.ksitem) ? _c('div', {
    staticStyle: {
      "padding-top": "88px"
    }
  }, [_c('div', {
    staticClass: "hrjoin-compy"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("申请企业")]), _vm._v(" "), _c('div', {
    staticClass: "compy-info flex"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.logourl
    }
  })]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "flex info-item"
  }, [_c('div', {
    staticClass: "compy-ft"
  }, [_vm._v("公司名称:")]), _vm._v(" "), _c('div', {
    staticClass: "compy-tx"
  }, [_vm._v(_vm._s(_vm.ksitem.ksname))])]), _vm._v(" "), _c('div', {
    staticClass: "flex info-item"
  }, [_c('div', {
    staticClass: "compy-ft"
  }, [_vm._v("公司地址:")]), _vm._v(" "), _c('div', {
    staticClass: "compy-tx"
  }, [_vm._v(_vm._s(_vm.ksitem.kscity))])]), _vm._v(" "), _c('div', {
    staticClass: "flex info-item"
  }, [_c('div', {
    staticClass: "compy-ft"
  }, [_vm._v("负责人:")]), _vm._v(" "), _c('div', {
    staticClass: "compy-tx"
  }, [_vm._v(_vm._s(_vm.ksitem.ksadname))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("验证信息")]), _vm._v(" "), _c('el-input', {
    staticClass: "com-input value",
    attrs: {
      "placeholder": "请输入验证消息"
    },
    model: {
      value: (_vm.applyRemark),
      callback: function($$v) {
        _vm.applyRemark = $$v
      },
      expression: "applyRemark"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_c('div', {
    staticClass: "primary-btn",
    on: {
      "click": _vm.join
    }
  }, [_vm._v("提交申请")])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3505bd5a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/register/hrapply.vue
// module id = 866
// module chunks = 1